/* ============================================
   catch it - Live Departure Viewer
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  const liveDepartures = document.getElementById('liveDepartures');
  const liveStation = document.getElementById('liveStation');
  const liveTime = document.getElementById('liveTime');
  const liveOperators = document.getElementById('liveOperators');
  const cityBtns = document.querySelectorAll('.live-city-btn');

  if (!liveDepartures || cityBtns.length === 0) return;

  // --- Randomize the city marquee order on each load (both loop halves stay in sync) ---
  (function shuffleCities() {
    const track = document.getElementById('liveCitiesTrack');
    if (!track) return;
    const items = Array.from(track.children);
    const half = items.length >> 1;
    if (half < 2) return;
    const first = items.slice(0, half);
    const second = items.slice(half);
    const order = first.map((_, i) => i);
    for (let i = order.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [order[i], order[j]] = [order[j], order[i]];
    }
    order.forEach(i => track.appendChild(first[i]));
    order.forEach(i => second[i] && track.appendChild(second[i]));
  })();

  // --- Constants ---
  const API_BASE = 'https://catchit-departures.nowakpaul11.workers.dev/?rbl=';
  let refreshTimer = null;

  // --- Line color mapping ---
  const lineColors = {
    'U1': '#e11d48', 'U2': '#7c3aed', 'U3': '#f97316', 'U4': '#16a34a', 'U6': '#a16207',
    'S1': '#2563eb', 'S2': '#16a34a', 'S3': '#dc2626', 'S4': '#0284c7', 'S7': '#f97316',
    'S40': '#2563eb', 'S45': '#16a34a', 'S50': '#0284c7', 'S60': '#7c3aed', 'S80': '#dc2626',
    'D': '#f59e0b', 'O': '#dc2626', 'N': '#525252',
    'ICE': '#dc2626', 'IC': '#dc2626', 'EC': '#0284c7', 'RJX': '#dc2626', 'RJ': '#dc2626',
    'REX': '#7c3aed', 'R': '#525252', 'CJX': '#0891b2', 'NJ': '#1e3a5f', 'EN': '#1e3a5f',
    'TGV': '#0284c7',
    // Muenchen
    'U7': '#c2a64d', 'U8': '#e11d48',
    // Paris
    'M1': '#f2c931', 'M4': '#a0006e', 'M6': '#76c882', 'M7': '#f59e0b',
    'A': '#dc2626', 'B': '#2563eb', 'T3a': '#f97316',
  };

  function getLineColor(name) {
    if (lineColors[name]) return lineColors[name];
    for (const [key, color] of Object.entries(lineColors)) {
      if (name.startsWith(key)) return color;
    }
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return `hsl(${Math.abs(hash) % 360}, 60%, 45%)`;
  }

  // Classify line name into operator type (must match filter tag names!)
  function classifyLine(name) {
    if (/^U\d/.test(name)) return 'U-Bahn';
    if (/^S\d/.test(name)) return 'S-Bahn';
    if (/^M\d/.test(name)) return 'Metro';
    if (/^T\d/.test(name)) return 'Tram';
    if (/^(RER|RER )?[A-E]$/.test(name)) return 'RER';
    if (/^(ICE|IC|EC|RJX|RJ|TGV|NJ|EN|WB|CJX)$/.test(name)) return 'Fernverkehr';
    if (/^REX/.test(name)) return 'S-Bahn';
    if (/^\d{1,2}[A-Z]?$/.test(name) || /^[DON]$/.test(name)) return 'Tram';
    return 'Bus';
  }

  // --- Demo data for cities without live API ---
  const demoData = {
    muenchen: [
      { line: 'U3', towards: 'Moosach', countdown: 2 },
      { line: 'S8', towards: 'Flughafen', countdown: 4 },
      { line: '19', towards: 'Pasing', countdown: 5 },
      { line: 'U7', towards: 'Neuperlach Zentrum', countdown: 7 },
      { line: 'S1', towards: 'Leuchtenbergring', countdown: 9 },
      { line: '17', towards: 'Amalienburgstra\u00dfe', countdown: 11 },
    ],
    berlin: [
      { line: 'U2', towards: 'Pankow', countdown: 1 },
      { line: 'S7', towards: 'Potsdam Hbf', countdown: 3 },
      { line: 'U6', towards: 'Alt-Mariendorf', countdown: 5 },
      { line: 'S1', towards: 'Oranienburg', countdown: 6 },
      { line: '12', towards: 'Am Kupfergraben', countdown: 8 },
      { line: 'U8', towards: 'Hermannstra\u00dfe', countdown: 10 },
    ],
    paris: [
      { line: 'M1', towards: 'La D\u00e9fense', countdown: 1 },
      { line: 'A', towards: 'Saint-Germain-en-Laye', countdown: 3 },
      { line: 'M4', towards: 'Mairie de Montrouge', countdown: 4 },
      { line: 'B', towards: 'A\u00e9roport CDG', countdown: 6 },
      { line: 'M6', towards: 'Nation', countdown: 8 },
      { line: 'T3a', towards: 'Pont du Garigliano', countdown: 12 },
    ],
    zuerich: [
      { line: 'S3', towards: 'Effretikon', countdown: 2 },
      { line: '11', towards: 'Rehalp', countdown: 3 },
      { line: 'S6', towards: 'Uetikon', countdown: 5 },
      { line: '4', towards: 'Tiefenbrunnen', countdown: 7 },
      { line: 'S16', towards: 'Herrliberg-Feldmeilen', countdown: 9 },
      { line: '15', towards: 'Bucheggplatz', countdown: 11 },
    ],
    hamburg: [
      { line: 'U3', towards: 'Barmbek', countdown: 1 },
      { line: 'S1', towards: 'Airport', countdown: 3 },
      { line: 'U1', towards: 'Ohlstedt', countdown: 5 },
      { line: 'S3', towards: 'Pinneberg', countdown: 6 },
      { line: 'U2', towards: 'Niendorf Nord', countdown: 8 },
      { line: '5', towards: 'Hauptbahnhof', countdown: 10 },
    ],
    amsterdam: [
      { line: 'M52', towards: 'Noord', countdown: 2 },
      { line: '2', towards: 'Nieuw Sloten', countdown: 3 },
      { line: 'M54', towards: 'Gein', countdown: 5 },
      { line: '5', towards: 'Amstelveen', countdown: 7 },
      { line: 'M50', towards: 'Isolatorweg', countdown: 9 },
      { line: '14', towards: 'Flevopark', countdown: 11 },
    ],
    prag: [
      { line: 'M1', towards: 'Nemocnice Motol', countdown: 1 },
      { line: '22', towards: 'B\u00edl\u00e1 Hora', countdown: 3 },
      { line: 'M3', towards: 'Let\u0148any', countdown: 4 },
      { line: '9', towards: 'S\u00eddli\u0161t\u011b \u0158epy', countdown: 6 },
      { line: 'M2', towards: '\u010cern\u00fd Most', countdown: 8 },
      { line: '17', towards: 'S\u00eddli\u0161t\u011b Mod\u0159any', countdown: 10 },
    ],
    barcelona: [
      { line: 'M1', towards: 'Hospital de Bellvitge', countdown: 2 },
      { line: 'S1', towards: 'Terrassa', countdown: 3 },
      { line: 'M3', towards: 'Zona Universit\u00e0ria', countdown: 5 },
      { line: 'T4', towards: 'Ciutadella', countdown: 7 },
      { line: 'M4', towards: 'La Pau', countdown: 8 },
      { line: 'S2', towards: 'Sabadell', countdown: 11 },
    ],
  };

  // --- Departure state ---
  let allDepartures = [];
  let activeFilter = null; // null = show all

  // --- Clock ---
  function updateTime() {
    if (liveTime) {
      const now = new Date();
      liveTime.textContent = now.toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    }
  }

  // --- Rendering ---
  function renderDepartures(deps) {
    const filtered = activeFilter
      ? deps.filter(d => d.operator === activeFilter)
      : deps;
    const top = filtered.slice(0, 6);

    if (top.length === 0) {
      liveDepartures.innerHTML = '<div class="live-error">No departures available right now.</div>';
      return;
    }
    liveDepartures.innerHTML = top.map(d => {
      const color = getLineColor(d.line);
      let countdownText, countdownClass;
      if (d.countdown === 0) {
        countdownText = 'NOW';
        countdownClass = 'now';
      } else if (d.countdown <= 2) {
        countdownText = d.countdown + ' min';
        countdownClass = 'soon';
      } else {
        countdownText = d.countdown + ' min';
        countdownClass = '';
      }
      const opTag = d.operator ? `<div class="live-op-label">${d.operator}</div>` : '';
      return `<div class="live-row">
        <div class="live-line-badge" style="background:${color}">${d.line}</div>
        <div class="live-dest"><span class="live-dest-name">${d.towards}</span>${opTag}</div>
        <div class="live-countdown ${countdownClass}">${countdownText}</div>
      </div>`;
    }).join('');
  }

  function applyFilter() {
    renderDepartures(allDepartures);
    // Update active state on operator tags
    if (liveOperators) {
      liveOperators.querySelectorAll('.live-operator-tag').forEach(tag => {
        tag.classList.toggle('active', tag.dataset.operator === activeFilter);
      });
    }
  }

  // --- Fetch from multiple RBLs in parallel ---
  async function fetchMultiDepartures(rbls) {
    liveDepartures.innerHTML = '<div class="live-loading"><div class="live-loading-spinner"></div><div>Loading...</div></div>';

    try {
      const rblList = rbls.split(',').map(r => r.trim());
      const results = await Promise.allSettled(
        rblList.map(rbl => fetch(API_BASE + encodeURIComponent(rbl)).then(r => r.json()))
      );

      const deps = [];
      for (let i = 0; i < results.length; i++) {
        if (results[i].status !== 'fulfilled') continue;
        const monitors = results[i].value.data?.monitors || [];
        for (const monitor of monitors) {
          if (!monitor) continue;
          for (const line of (monitor.lines || [])) {
            for (const dep of (line.departures?.departure || [])) {
              const countdown = dep.departureTime?.countdown;
              if (countdown == null) continue;
              const lineName = dep.vehicle?.name || line.name || '?';
              deps.push({
                line: lineName,
                towards: (dep.vehicle?.towards || line.towards || '').trim(),
                countdown: countdown,
                operator: classifyLine(lineName),
              });
            }
          }
        }
      }

      deps.sort((a, b) => a.countdown - b.countdown);
      allDepartures = deps;
      renderDepartures(deps);
    } catch (err) {
      liveDepartures.innerHTML = '<div class="live-error">Could not load departures. Try again later.</div>';
    }
  }

  // --- Demo mode ---
  function showDemo(city) {
    liveDepartures.innerHTML = '<div class="live-loading"><div class="live-loading-spinner"></div><div>Loading...</div></div>';
    setTimeout(() => {
      const data = demoData[city] || [];
      const deps = data.map(d => ({
        ...d,
        countdown: Math.max(0, d.countdown + Math.floor(Math.random() * 3) - 1),
        operator: classifyLine(d.line),
      }));
      deps.sort((a, b) => a.countdown - b.countdown);
      allDepartures = deps;
      renderDepartures(deps);
    }, 600);
  }

  // --- Operator filter tags ---
  function updateOperators(operators) {
    if (!liveOperators) return;
    activeFilter = null;
    const tags = operators.split(',').map(op => {
      const name = op.trim();
      return `<span class="live-operator-tag" data-operator="${name}">${name}</span>`;
    }).join('');
    liveOperators.innerHTML = tags;

    // Attach click handlers for filtering
    liveOperators.querySelectorAll('.live-operator-tag').forEach(tag => {
      tag.addEventListener('click', () => {
        const op = tag.dataset.operator;
        activeFilter = (activeFilter === op) ? null : op;
        applyFilter();
      });
    });
  }

  // --- Start live departures for a city ---
  function startLive(btn) {
    const rbls = btn.dataset.rbls;
    const station = btn.dataset.station;
    const city = btn.dataset.city;
    const operators = btn.dataset.operators || '';

    if (liveStation) liveStation.textContent = station;
    updateOperators(operators);
    if (refreshTimer) clearInterval(refreshTimer);

    if (rbls === 'demo') {
      showDemo(city);
      refreshTimer = setInterval(() => showDemo(city), 30000);
    } else {
      fetchMultiDepartures(rbls);
      refreshTimer = setInterval(() => fetchMultiDepartures(rbls), 30000);
    }
  }

  // --- Product CTA ---
  const productBtn = document.getElementById('liveProductBtn');
  const productText = document.getElementById('liveProductText');

  function updateProductCta(btn) {
    if (!productBtn || !productText) return;
    const product = btn.dataset.product || 'City-Station';
    // Train-station departures → Train-Station product; city departures → the Original (dein catch it)
    productBtn.href = product === 'Train-Station' ? '/products/train-station' : '/products/city-edition';
    const de = 'Jetzt dein catch it holen';
    const en = 'Get your catch it now';
    productText.setAttribute('data-de', de);
    productText.setAttribute('data-en', en);
    const lang = (window.catchitI18n && window.catchitI18n.getLang) ? window.catchitI18n.getLang() : (document.documentElement.lang || 'en');
    productText.textContent = lang === 'de' ? de : en;
  }

  // --- Marquee city buttons ---
  const marquee = document.getElementById('liveCitiesMarquee');

  function activateCity(btn) {
    // Remove active from all buttons (both sets in marquee)
    document.querySelectorAll('.live-city-btn').forEach(b => b.classList.remove('active'));
    // Activate all buttons with same city (both sets)
    document.querySelectorAll(`.live-city-btn[data-city="${btn.dataset.city}"]`).forEach(b => b.classList.add('active'));
    startLive(btn);
    updateProductCta(btn);
  }

  let activeCity = null;

  // City button clicks -- toggle pause/resume
  cityBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.dataset.city === activeCity && marquee && marquee.classList.contains('paused')) {
        // Same city clicked again -> resume marquee
        marquee.classList.remove('paused');
        document.querySelectorAll('.live-city-btn').forEach(b => b.classList.remove('active'));
        activeCity = null;
      } else {
        // New city -> pause and show
        if (marquee) marquee.classList.add('paused');
        activeCity = btn.dataset.city;
        activateCity(btn);
      }
    });
  });

  // Update clock every second
  updateTime();
  setInterval(updateTime, 1000);

  // Start with first city
  activateCity(cityBtns[0]);

});
